import { useCallback, useEffect, useState } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import { ActivePaymentOptionResponseDto } from '@tiendanube/common';
import { useAppDispatch } from 'App/store';
import { StatusType } from 'commons/types';
import { getActivePaymentOptionsAction } from 'domains/Payments/PaymentProviders/paymentProvidersSlice';

function useGetActivePaymentOptions() {
  const dispatch = useAppDispatch();
  const [status, setStatus] = useState<StatusType>('idle');
  const [activePaymentOptions, setActivePaymentOptions] =
    useState<ActivePaymentOptionResponseDto[]>();

  const fetchActivePaymentOptions = useCallback(async () => {
    setStatus('loading');

    try {
      const data = await dispatch(getActivePaymentOptionsAction());
      const activePaymentOptions = unwrapResult(data);

      setActivePaymentOptions(activePaymentOptions);
      setStatus('success');
    } catch (error) {
      setStatus('error');
    }
  }, [dispatch]);

  useEffect(() => {
    fetchActivePaymentOptions();
  }, [fetchActivePaymentOptions]);

  return {
    isLoading: status === 'loading',
    isError: status === 'error',
    isSuccess: status === 'success',
    activePaymentOptions: activePaymentOptions ?? [],
    reload: fetchActivePaymentOptions,
  };
}

export default useGetActivePaymentOptions;
